/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useRef, useState } from 'react'


import { useTranslation } from 'src/utils/i18n'
import Card from '@mui/material/Card'
import Grid from '@mui/material/Grid'

import Image from 'next/image'
import { useAndroidDevicePagedData } from 'src/hooks/useAndroidDevicePagedData'

//@mui/material
import TextField from '@mui/material/TextField'
import InputAdornment from '@mui/material/InputAdornment'

import { useDispatch } from 'react-redux'
import { setCurrentTab } from 'src/store/apps/Common'
import ContentLoading from 'src/components/ContentLoading'

const Apps = () => {
  const dispatch = useDispatch()
  let Advanced = window.localStorage.getItem('Advanced')
  Advanced = Advanced == null || Advanced == 0 ? true : false

  const [allApp, setAllApp] = useState([])
  const [useApp, setApp] = useState([])
  const { context, data: appRecords, loading: isLoading, loadNext } = useAndroidDevicePagedData({
    source: 'local',
    category: 'INSTALLED_APP',
    limit: 50
  })

  useEffect(() => {
    setAllApp(appRecords)
    setApp(appRecords)
  }, [appRecords])

  useEffect(() => {
    setScroll(0)
  }, [context?.requestKey])

  const dom = useRef(null)

  // 滚动百分比
  const [scroll, setScroll] = useState(0)

  // 获取滚动百分比
  useEffect(() => {
    const handScroll = () => {
      if (dom.current) {
        const { scrollTop, scrollHeight, clientHeight } = dom.current
        const progress = scrollTop / (scrollHeight - clientHeight) * 100

        setScroll(progress.toFixed(0))
      }
    }

    const currentRef = dom.current
    if (currentRef) {
      currentRef.addEventListener('scroll', handScroll)
    }

    return () => {
      if (currentRef) {
        currentRef.removeEventListener('scroll', handScroll)
      }
    }
  }, [])

  // 监听滚动百分比
  useEffect(() => {
    if (scroll >= 100) loadNext()
  }, [loadNext, scroll])

  const handleImageError = event => {
    event.target.src = '/images/android/com.example.variousdata.png'
  }

  // 处理搜索app
  const handleFilter = async e => {
    const query = e.target.value.toLowerCase() // 转换为小写以确保不区分大小写

    if (query === '') {
      setApp(allApp) // 如果输入为空，显示所有应用程序
    } else {
      const filteredApps = allApp.filter(
        app => app.name.toLowerCase().includes(query) // 假设每个应用都有一个 'name' 属性
      )
      setApp(filteredApps) // 将过滤后的结果设置到 useApp 中
    }
  }

  const { t } = useTranslation('common')
  useEffect(() => {
    const title = t('Installed app')
    dispatch(setCurrentTab(title))

    return () => dispatch(setCurrentTab(''))
  }, [dispatch, t])

  return (
    <>
      {/* <Card style={{ padding: '18px' }}> */}
      <div className='bg-[#FFF] drop-shadow-[0_0_12px_rgba(0,0,0,0.13)] rounded-[10px] Bxl:h-[calc(var(--vh2)*100-90px)] Bxls:Headers5:h-[calc(var(--vh2)*100-145px)] Header5:big:h-[calc(var(--vh2)*100-210px)] bigs:h-[calc(var(--vh2)*100-270px)] flex flex-col relative'>
        {/* 搜索框 */}
        <div className='w-full mb-[18px] flex flex-col pt-[15px] px-[15px]'>
          <TextField
            fullWidth
            className='h-[40px] bg-[rgba(235,235,239,0.92)] rounded-lg !border-0 text-[16px]'
            size='small'
            onInput={e => {
              handleFilter(e)
            }}
            placeholder={t('Search app')}
            sx={{
              '& .MuiInputBase-root .MuiOutlinedInput-notchedOutline': { border: 0 },
              '& input::placeholder': { fontSize: '16px', color: '#818187', opacity: 100 }
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position='start'>
                  {/* <Icon icon='mdi:magnify' fontSize='1.25rem' /> */}
                  <Image src='/images/contacts/search.svg' width={18} height={18} alt='search'></Image>
                </InputAdornment>
              )
            }}
          />
        </div>
        <div ref={dom} className='flex-1 overflow-auto px-[24px] pb-[22px]'>
          <Grid container columnSpacing={8.75} rowSpacing={5.25}>
            {useApp.map((row, index) => (
              <Grid
                item
                key={row.bundleid || row.bundleId || index}
                xs={3}
                md={2}
                lg={2}
                style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}
              >
                <Image
                  className='rounded-[11px] sm:h-[48px] sm:w-[48px]'
                  src={'https://cos.spyx.com/' + row.iconUrl}
                  width={50}
                  height={50}
                  alt='img'
                  onError={handleImageError}
                />
                {/* 应用名固定 12px：sm: 前缀在手机端不生效会退回默认字号导致名称被裁；break-all 让 bundleid 等长词可换行显示完整 */}
                <p
                  className='text-[12px] break-all mt-[4px] overflow-hidden w-full items-end text-center text-[#2E2E2E] font-medium'
                  style={{
                    display: '-webkit-box',
                    WebkitLineClamp: '2',
                    WebkitBoxOrient: 'vertical'
                  }}
                >
                  {row.name == '' ? row.bundleid || row.bundleId : row.name}
                </p>
              </Grid>
            ))}
          </Grid>
        </div>
        {/* </Card> */}
        {isLoading ? (
        <div className='absolute inset-0 z-[20] bg-[#FFF] rounded-[10px]'>
          <ContentLoading />
        </div>
      ) : null}
{(allApp.length > 0 || isLoading) ||
          <div className='text-center px-2 absolute inset-0 flex justify-center items-center pointer-events-none'>
            {t('It appears theres no data to show here yet')}<br />
            {t('If data exists it may take up to 1 hour to download and appear')}<br />
            {t('We suggest checking back in a little while')}
          </div>}
      </div>
    </>
  )
}

export default Apps


